var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-editor"},[_c('TypeSelector',_vm._b({attrs:{"object-type":"Filter","type-options":_vm.filterTypes},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}},'TypeSelector',_vm.subObjectBinds,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }